import { createFileRoute, redirect } from '@tanstack/react-router'
import { supabase } from '@/lib/supabaseClient'

export const Route = createFileRoute('/clerk/_authenticated/')({
  // Dynamically import the layout to enable code-splitting and avoid MIME issues
  component: () =>
    import('@/components/layout/authenticated-layout').then((mod) => mod.AuthenticatedLayout),

  // Optional: route guard using Supabase session check
  beforeLoad: async () => {
    const {
      data: { session },
    } = await supabase.auth.getSession()

    if (!session) {
      throw redirect({
        to: '/sign-in',
        search: { redirect: window.location.pathname },
      })
    }
  },
})
